module.exports = __webpack_public_path__ + "img/product_icon.53b6521c.png";